import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { selectAssociativeLanguages, selectLanguages } from '../selectors/app'

import { useCountryCode } from './useCountryCode'

const initialCrud = new Crud<{ name: string; value: string }>({
  fetcher: new Static([] as Array<{ name: string; value: string }>),
  keyField: 'name',
})

export const usePreferredLanguageSource = (countryOfBusiness?: string, previousValue?: string) => {
  const [source, setSource] = useState<Crud<{ name: string; value: string }>>(initialCrud)
  const [isRequiredDataExist, setIsRequiredDataExist] = useState(false)
  const countryCode = useCountryCode(countryOfBusiness || '')
  const associativeLanguage = useSelector(selectAssociativeLanguages)
  const languages = useSelector(selectLanguages)

  useEffect(() => {
    const filteredAssociativeLanguage = associativeLanguage.filter(
      (lang) => countryOfBusiness && lang.CountryCode === countryCode
    )
    const previousLanguage = languages.find(({ name }) => name === previousValue)
    const preferredLanguages = filteredAssociativeLanguage.map((lang) => {
      const prettyLanguage = languages.find(({ value }) => value === lang.value)

      return {
        name: (prettyLanguage && prettyLanguage.name) || lang.name,
        value: (prettyLanguage && prettyLanguage.value) || lang.value,
      }
    })

    const sourceContent = previousLanguage
      ? [
          previousLanguage,
          ...preferredLanguages.filter(({ value }) => previousLanguage.value !== value),
        ]
      : preferredLanguages

    setIsRequiredDataExist(!!sourceContent.length)

    const preferredLanguagesSource = new Crud({
      fetcher: new Static(sourceContent),
      keyField: 'name',
    })

    setSource(preferredLanguagesSource)
  }, [associativeLanguage, countryCode, countryOfBusiness, languages, previousValue])

  return { source, isRequiredDataExist }
}
